__turbopack_context__.v({
  "cardWrapper": "upcomingEvents-module__g7Ql_G__cardWrapper",
  "eventsGrid": "upcomingEvents-module__g7Ql_G__eventsGrid",
  "noEvents": "upcomingEvents-module__g7Ql_G__noEvents",
  "sectionSubtitle": "upcomingEvents-module__g7Ql_G__sectionSubtitle",
  "upcomingHeader": "upcomingEvents-module__g7Ql_G__upcomingHeader",
  "upcomingSection": "upcomingEvents-module__g7Ql_G__upcomingSection",
  "upcomingTitle": "upcomingEvents-module__g7Ql_G__upcomingTitle",
});
